export default "__VITE_ASSET__dAr253tF__"